export enum PaymentMethod {
  PaymentViaDomicilie = 'Payment via Domicilie',
  ManualPayment = 'Manual payment',
}
